import { Link } from "react-router-dom"
import ScrollToTopBtn from "./Scrolltotop"

const Footer = () => {
    return (
        <>
            <footer>
                <div className="footer-top">
                    <div className="container">
                        <div className="row g-4">

                            <div className="col-lg-4">
                                <div className="footer-logo-text"><img src="images/logo.png" height={78} className="rounded" alt="" /></div>
                                <p className="footer-desc">
                                    Providing premium logistic services since 1989. Domestic & International Courier, Cargo and Logistics — delivering trust, every shipment.
                                </p>
                            </div>

                            <div className="col-lg-2 col-6">
                                <div className="footer-heading">Quick Links</div>
                                <ul className="footer-links">
                                    <li><Link onClick={() => window.scrollTo(0, 0)} to="/">Home</Link></li>
                                    <li><Link onClick={() => window.scrollTo(0, 0)} to="about-us">About Us</Link></li>
                                    <li><Link onClick={() => window.scrollTo(0, 0)} to="services">Services</Link></li>
                                    <li><Link onClick={() => window.scrollTo(0, 0)} to="/tracking">Tracking</Link></li>
                                    <li><Link onClick={() => window.scrollTo(0, 0)} to="/contact-us">Contact Us</Link></li>
                                    <li><Link onClick={() => window.scrollTo(0, 0)} to="faqs">FAQ's</Link></li>
                                </ul>
                            </div>

                            <div className="col-lg-3 col-6">
                                <div className="footer-heading">Our Services</div>
                                <ul className="footer-links">
                                    <li><Link onClick={() => window.scrollTo(0, 0)} to="/services#express-services">Express Services</Link></li>
                                    <li><Link onClick={() => window.scrollTo(0, 0)} to="/services#domestic-services">Domestic Services</Link></li>
                                    <li><Link onClick={() => window.scrollTo(0, 0)} to="/services#time-definite">Time Definite</Link></li>
                                    <li><Link onClick={() => window.scrollTo(0, 0)} to="/services#sameday">Sameday Delivery</Link></li>
                                    <li><Link onClick={() => window.scrollTo(0, 0)} to="/services#oxford-engineering">Oxford Engineering</Link></li>
                                </ul>
                            </div>

                            <div className="col-lg-3">
                                <div className="footer-heading">Contact Info</div>
                                <ul className="footer-links">

                                    <li>
                                        <i className="fa fa-phone me-2" style={{ color: "var(--red)" }}></i>
                                        +91 96672 33072
                                    </li>

                                    <li>
                                        <i className="fa fa-envelope me-2" style={{ color: "var(--red)" }}></i>
                                        oxford_express@yahoo.co.in
                                    </li>

                                    <li>
                                        <i className="fa fa-envelope me-2" style={{ color: "var(--red)" }}></i>
                                        info@oxfordexp.com
                                    </li>

                                    <li className="mt-2">
                                        <i className="fa fa-map-marker-alt me-2" style={{ color: "var(--red)" }}></i>
                                        B-9 Laxmi Bhawan 72, Nehru place New Delhi - 110019.
                                    </li>

                                </ul>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="container d-flex justify-content-between flex-wrap gap-2">

                        <div>
                            Copyright 2026. Oxford Express Private Limited — All Rights Reserved.
                        </div>

                        <div>
                            <p>Design By <Link to='https://www.sagarinfotech.com/'>SIPL</Link></p>
                        </div>

                    </div>
                </div>
            </footer>
            <ScrollToTopBtn />
        </>
    )
}

export default Footer